import * as React from 'react';
import type { SVGProps } from 'react';

const BagIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.66283 6.65366H6.42635C5.57194 6.65366 4.86272 7.31402 4.80176 8.16657L4.00413 19.3353C3.97202 19.7863 4.12837 20.2302 4.43644 20.5611C4.74498 20.892 5.17638 21.08 5.62872 21.08H18.5212C18.9735 21.08 19.4049 20.892 19.7135 20.5611C20.0215 20.2302 20.1779 19.7863 20.1458 19.3353L19.3482 8.16657C19.2872 7.31402 18.578 6.65366 17.7236 6.65366H16.4959V6.42098C16.4959 3.9792 14.5167 2 12.075 2C9.72254 2 7.54835 3.87356 7.65398 6.42098C7.65724 6.49823 7.66004 6.57594 7.66283 6.65366ZM16.4959 8.04976V11.54C16.4959 11.9253 16.1832 12.238 15.7979 12.238C15.4126 12.238 15.0998 11.9253 15.0998 11.54V8.04976H9.05008V11.54C9.05008 11.9253 8.73736 12.238 8.35203 12.238C7.96671 12.238 7.65398 11.9253 7.65398 11.54C7.65398 11.54 7.71448 9.90889 7.69447 8.04976H6.42635C6.30442 8.04976 6.20298 8.14422 6.1946 8.26568L5.39649 19.4345C5.39183 19.4991 5.41418 19.5624 5.45839 19.6099C5.5026 19.6569 5.56403 19.6839 5.62872 19.6839H18.5212C18.5859 19.6839 18.6473 19.6569 18.6915 19.6099C18.7357 19.5624 18.7581 19.4991 18.7534 19.4345L17.9553 8.26568C17.9469 8.14422 17.8455 8.04976 17.7236 8.04976H16.4959ZM15.0998 6.65366V6.42098C15.0998 4.75031 13.7456 3.3961 12.075 3.3961C10.4043 3.3961 9.05008 4.75031 9.05008 6.42098V6.65366H15.0998Z"
      fill="currentColor"
      stroke="#9099A5"
      strokeWidth="0.6"
    />
  </svg>
);

export default BagIcon;
